export default __webpack_public_path__ + "static/media/Tatiana.8565362b.png";